import { Button } from '../Button';

interface SettingsButtonProps {
  onClick: () => void;
}

export function SettingsButton({ onClick }: SettingsButtonProps) {
  return (
    <Button
      onClick={onClick}
      aria-label="設定を開く"
      className="fixed left-16 top-16 z-10"
    >
      設定
    </Button>
  );
}
